if(typeof lozad === 'function') {
	const observer = lozad(); // lazy loads elements with default selector as '.lozad'
	observer.observe();
}
